import { render, staticRenderFns } from "./Myprofile.vue?vue&type=template&id=1d940984&"
import script from "./Myprofile.vue?vue&type=script&lang=ts&"
export * from "./Myprofile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports